export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function formatTime(isoStr: string): string {
  try {
    const d = new Date(isoStr);
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  } catch {
    return isoStr;
  }
}

export function formatDistance(meters: number): string {
  if (meters >= 1609) {
    return `${(meters / 1609.34).toFixed(1)} mi`;
  }
  return `${Math.round(meters)} m`;
}

export function formatDelay(seconds: number): string {
  if (seconds === 0) return 'On time';
  const abs = Math.abs(seconds);
  const mins = Math.floor(abs / 60);
  const suffix = seconds > 0 ? 'late' : 'early';
  if (mins > 0) return `${mins}m ${abs % 60}s ${suffix}`;
  return `${abs}s ${suffix}`;
}

export function delayColor(seconds: number): string {
  if (seconds <= 0) return '#22c55e';
  if (seconds <= 180) return '#eab308';
  return '#ef4444';
}

const METRO_LETTER_RE = /^METRO\s+([A-E])\s+Line$/i;

export function getRouteLabel(leg: { mode: string; route?: { shortName?: string; longName?: string } | null }): string {
  const sn = leg.route?.shortName || '';
  const ln = leg.route?.longName || '';

  const m = ln.match(METRO_LETTER_RE);
  if (m) return m[1].toUpperCase();

  const name = (sn || ln).toLowerCase();
  if (name.includes('blue line')) return 'Blue';
  if (name.includes('green line')) return 'Green';
  if (name.includes('red line')) return 'Red';
  if (name.includes('orange line')) return 'Orange';
  if (name.includes('gold line')) return 'Gold';
  if (ln.toLowerCase().includes('blue line bus')) return 'BL Bus';

  return sn || leg.mode;
}

export function getRouteBadgeColor(leg: { mode: string; route?: { shortName?: string; longName?: string } | null }): string {
  const sn = leg.route?.shortName || '';
  const ln = leg.route?.longName || '';
  const name = (sn || ln).toLowerCase();

  if (name.includes('blue line')) return '#2563eb';
  if (name.includes('green line')) return '#16a34a';
  if (name.includes('red line')) return '#dc2626';
  if (name.includes('orange line')) return '#ea580c';
  if (name.includes('gold line')) return '#eab308';
  if (METRO_LETTER_RE.test(ln)) return '#6b7280';
  if (leg.mode === 'RAIL' || leg.mode === 'TRAM' || leg.mode === 'SUBWAY') return '#16a34a';
  if (leg.mode === 'BUS') return '#3b82f6';
  return '#6b7280';
}

export function modeIcon(mode: string): string {
  switch (mode) {
    case 'BICYCLE': return '\uD83D\uDEB2';
    case 'BUS': return '\uD83D\uDE8C';
    case 'RAIL':
    case 'TRAM':
    case 'SUBWAY': return '\uD83D\uDE82';
    case 'WALK': return '\uD83D\uDEB6';
    case 'FERRY': return '\u26F5';
    default: return '\u2794';
  }
}

export function modeColor(mode: string): string {
  switch (mode) {
    case 'BICYCLE': return '#e94560';
    case 'WALK': return '#999999';
    case 'BUS': return '#3b82f6';
    case 'RAIL':
    case 'TRAM':
    case 'SUBWAY': return '#22c55e';
    case 'FERRY': return '#a855f7';
    default: return '#666666';
  }
}
